export default "__VITE_ASSET__BHT9jchG__"